import { render, staticRenderFns } from "./SearchFilterTokens2.vue?vue&type=template&id=0061326e&scoped=true&"
import script from "./SearchFilterTokens2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0061326e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0061326e')) {
      api.createRecord('0061326e', component.options)
    } else {
      api.reload('0061326e', component.options)
    }
    module.hot.accept("./SearchFilterTokens2.vue?vue&type=template&id=0061326e&scoped=true&", function () {
      api.rerender('0061326e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2yuoqbQJGxuRd/JS/comp/SearchFilterTokens2.vue"
export default component.exports